import {
  MenuItem,
  ActionMenuItem,
  BLOG_ITEM,
  TESTIMONY_ITEM,
} from '@/types/menu';

export const MENU_ITEMS: {
  main: MenuItem[];
  actions: ActionMenuItem[];
} = {
  main: [
    {
      label: 'PARA VOCÊ',
      services: [
        {
          label: 'tagCAIXA',
          href: 'https://minhacontatag.caixaprepagos.com.br/',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_VOCE-tagCAIXA.png',
            title: 'PARA VOCÊ TAG CAIXA',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: 'https://ecommerce.caixaprepagos.com.br/',
          },
          instructions: [
            {
              label: 'ADQUIRA JÁ',
              href: 'https://ecommerce.caixaprepagos.com.br/',
            },
            {
              label: 'PORTAL DO USUÁRIO',
              href: 'https://minhacontatag.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'CAIXA Alimentação',
          href: 'https://voce.caixaprepagos.com.br/',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_VOCE-alimentacao.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 2',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: 'https://voce.caixaprepagos.com.br/',
          },
          instructions: [
            {
              label: 'PORTAL DO USUÁRIO',
              href: 'https://voce.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'CAIXA Refeição',
          href: 'https://voce.caixaprepagos.com.br/',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_VOCE-refeicao.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 3',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: 'https://voce.caixaprepagos.com.br/',
          },
          instructions: [
            {
              label: 'PORTAL DO USUÁRIO',
              href: 'https://voce.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'CAIXA Multi',
          href: 'https://voce.caixaprepagos.com.br/',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_VOCE-multi.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 4',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: 'https://voce.caixaprepagos.com.br/',
          },
          instructions: [
            {
              label: 'PORTAL DO USUÁRIO',
              href: 'https://voce.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'Parcerias',
          href: 'https://parcerias.caixaprepagos.com.br/',
          instructions: [
            {
              label: 'PORTAL DE PARCERIAS',
              href: 'https://parcerias.caixaprepagos.com.br/',
            },
          ],
        },
      ],
    },
    {
      label: 'PARA SUA EMPRESA',
      services: [
        {
          label: 'CAIXA Alimentação',
          href: '/alimentacao',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-alimentacao.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/alimentacao',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/alimentacao',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/alimentacao/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/alimentacao/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/alimentacao/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/alimentacao/#faq',
            // },
            {
              label: 'PORTAL DO RH',
              href: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/',
            },
            {
              label: 'MARKETPLACE',
              href: 'https://marketplace.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'CAIXA Refeição',
          href: '/refeicao',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-refeicao.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 2',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/refeicao',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/refeicao',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/refeicao/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/refeicao/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/refeicao/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/refeicao/#faq',
            // },
            {
              label: 'PORTAL DO RH',
              href: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/',
            },
            {
              label: 'MARKETPLACE',
              href: 'https://marketplace.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'CAIXA Multi',
          href: '/multi',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-multi.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 3',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/multi',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/multi',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/multi/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/multi/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/multi/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/multi/#faq',
            // },
            {
              label: 'PORTAL DO RH',
              href: 'https://empresa.caixaprepagos.com.br/portal/portal-caixa/login/',
            },
            {
              label: 'MARKETPLACE',
              href: 'https://marketplace.caixaprepagos.com.br/',
            },
          ],
        },
        {
          label: 'tagCAIXA Empresas',
          href: '/tagcaixa',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-tagCAIXA.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 4',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/tagcaixa',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/tagcaixa',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/tagcaixa/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/tagcaixa/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/tagcaixa/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/tagcaixa/#faq',
            // },
            {
              label: 'PORTAL DA EMPRESA',
              href: 'https://speseguro.caixaprepagos.com.br/loginCAIXA',
            },
          ],
        },
        {
          label: 'frotaCAIXA',
          href: '/frotacaixa',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-frota.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 5',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/frotacaixa',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/frotacaixa',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/frotacaixa/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/frotacaixa/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/frotacaixa/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/frotacaixa/#faq',
            // },
            {
              label: 'PORTAL DA EMPRESA',
              href: 'https://frota.caixaprepagos.com.br/portalcartaocaixa/login/autenticacaocaixa',
            },
          ],
        },
        {
          label: 'vtCAIXA',
          href: '/vtcaixa',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-vtCAIXA.png',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 6',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/vtcaixa',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/vtcaixa',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/vtcaixa/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/vtcaixa/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/vtcaixa/#ondeusar',
            },
            // {
            //   label: 'FAQ',
            //   href: '/vtcaixa/#faq',
            // },
            {
              label: 'PORTAL DO RH',
              href: 'https://valetransporte.caixaprepagos.com.br/caixa/login',
            },
          ],
        },
        {
          label: 'despesaCAIXA',
          href: '/despesacaixa',
          cardInfo: {
            imgSrc: '/assets/menu-cards-imgs/PARA_SUA_EMPRESA-despesaCAIXA.jpg',
            title: 'LOREM IPSUM FEUGIAT EUISMOD MATTIS 6',
            descrition:
              'Ornare suspendisse tristique est viverra adipiscing a arcu. Elementum interdum.',
            href: '/vtcaixa',
          },
          instructions: [
            {
              label: 'PEÇA SUA PROPOSTA',
              href: '/despesacaixa',
            },
            {
              label: 'COMO FUNCIONA',
              href: '/despesacaixa/#comofunciona',
            },
            {
              label: 'DIFERENCIAIS',
              href: '/despesacaixa/#diferenciais',
            },
            {
              label: 'ONDE USAR',
              href: '/despesacaixa/#ondeusar',
            },
            {
              label: 'PORTAL EMPRESA',
              href: 'https://mobe.caixaprepagos.com.br/caixa/login',
            },
            // {
            //   label: 'FAQ',
            //   href: '/alimentacao/#faq',
            // },
          ],
        },
      ],
    },
    {
      label: 'BLOG',
      href: '/blog',
    },
  ],
  actions: [
    {
      label: 'JÁ SOU CLIENTE',
      href: '#login',
      variant: 'ghost',
      className: 'border border-white text-white',
    },
    {
      label: 'ADQUIRA JÁ',
      href: '#adquira',
      variant: 'secondary',
      className: 'text-white',
    },
  ],
};

export const BLOG_ITEMS: {
  items: BLOG_ITEM[];
} = {
  items: [
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
    {
      tag: 'PARA VOCÊ',
      title: 'Vitae cras arcu ac risus.',
      description:
        'Lectus quis elementum aenean turpis egestas id malesuada mauris lobortis aliquam metus dignissim.',
      img_src: '/assets/blog-imgs/blog-1.jpg',
    },
  ],
};

export const TESTIMONY_ITEMS: {
  items: TESTIMONY_ITEM[];
} = {
  items: [
    {
      testimony:
        ' Lorem ipsum dolor sit amet consectetur. Cursus sit aliquam at placerat purus euismod nibh. Nunc nec mauris vitae sed viverra vivamus lorem. Tristique consectetur id ac fermentum varius elit risus nisi. Potenti at tristique augue id ac. Nullam tellus pretium tincidunt sed amet urna nibh.',
      img_src: '/assets/testimony-imgs/profile.jpg',
      name: 'Morgana Lyra',
      ocupation: 'Gerente de RH',
    },
    {
      testimony:
        ' Lorem ipsum dolor sit amet consectetur. Cursus sit aliquam at placerat purus euismod nibh. Nunc nec mauris vitae sed viverra vivamus lorem. Tristique consectetur id ac fermentum varius elit risus nisi. Potenti at tristique augue id ac. Nullam tellus pretium tincidunt sed amet urna nibh.',
      img_src: '/assets/testimony-imgs/profile.jpg',
      name: 'Morgana Lyra',
      ocupation: 'Gerente de RH',
    },
    {
      testimony:
        ' Lorem ipsum dolor sit amet consectetur. Cursus sit aliquam at placerat purus euismod nibh. Nunc nec mauris vitae sed viverra vivamus lorem. Tristique consectetur id ac fermentum varius elit risus nisi. Potenti at tristique augue id ac. Nullam tellus pretium tincidunt sed amet urna nibh.',
      img_src: '/assets/testimony-imgs/profile.jpg',
      name: 'Morgana Lyra',
      ocupation: 'Gerente de RH',
    },
    {
      testimony:
        ' Lorem ipsum dolor sit amet consectetur. Cursus sit aliquam at placerat purus euismod nibh. Nunc nec mauris vitae sed viverra vivamus lorem. Tristique consectetur id ac fermentum varius elit risus nisi. Potenti at tristique augue id ac. Nullam tellus pretium tincidunt sed amet urna nibh.',
      img_src: '/assets/testimony-imgs/profile.jpg',
      name: 'Morgana Lyra',
      ocupation: 'Gerente de RH',
    },
    {
      testimony:
        ' Lorem ipsum dolor sit amet consectetur. Cursus sit aliquam at placerat purus euismod nibh. Nunc nec mauris vitae sed viverra vivamus lorem. Tristique consectetur id ac fermentum varius elit risus nisi. Potenti at tristique augue id ac. Nullam tellus pretium tincidunt sed amet urna nibh.',
      img_src: '/assets/testimony-imgs/profile.jpg',
      name: 'Morgana Lyra',
      ocupation: 'Gerente de RH',
    },
  ],
};
